import { CreditCards } from "./enums";

export const brandFromNumber = num => {
	num = (num + "").replace(/\D/g, "");
	let cards = Object.keys(CreditCards);
	for (let i = 0; i < cards.length; i = i + 1) {
		let card = CreditCards[cards[i]];
		if (card.pattern.test(num)) {
			return card;
		}
	}
};
